import { render, staticRenderFns } from "./dealRecord.vue?vue&type=template&id=45c4457e&"
import script from "./dealRecord.vue?vue&type=script&lang=js&"
export * from "./dealRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports